import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import App from './containers/App';
import { initialState as initialAppState } from './reducer/app';
import { EASYBIB, OAProfileCode } from './types';
import { HEADING, SUBHEADING } from './standalone/defaults';
import { Environment, getClientId, init } from '@chegg/one-auth-sdk';
import isProduction from './standalone/isProduction';
import { getProfileCode } from './util/getProfileConfig';
import { getCookieDomain } from './util/getCookieDomain';
var env = isProduction() ? Environment.prod : Environment.test;
var authGateUrlSubDomain = isProduction() ? 'auth-gate' : 'auth-gate.playground';

// eslint-disable-next-line max-len
export var ERROR_ONE_PROP_REQUIRED = 'If you need a hard redirect, pass `editorBaseUrl`, if you want a custom transition pass `onUploadSuccess`.';
var defaultProps = {
  site: EASYBIB,
  headingText: HEADING,
  subheadingText: SUBHEADING
};
var Dropin = function Dropin(props) {
  var headingText = props.headingText,
    subheadingText = props.subheadingText,
    onUploadSuccess = props.onUploadSuccess,
    editorBaseUrl = props.editorBaseUrl,
    authApiUrl = props.authApiUrl,
    onAuthUpdate = props.onAuthUpdate,
    site = props.site,
    wtaiUploadUrl = props.wtaiUploadUrl,
    wtaiExpressUrl = props.wtaiExpressUrl,
    initFreshToken = props.initFreshToken,
    pasteOnly = props.pasteOnly,
    alignText = props.alignText,
    initRSW = props.initRSW,
    includeTerms = props.includeTerms,
    termsTextColor = props.termsTextColor,
    onEnterText = props.onEnterText,
    onCtaActivated = props.onCtaActivated,
    onCtaClicked = props.onCtaClicked,
    onComputerCtaClicked = props.onComputerCtaClicked,
    onGoogleDriveCtaClicked = props.onGoogleDriveCtaClicked,
    affiliateConfig = props.affiliateConfig,
    checkCategory = props.checkCategory,
    demoTextEnabled = props.demoTextEnabled,
    isResubmit = props.isResubmit,
    filename = props.filename;
  var cookieDomain = getCookieDomain(site);
  if (!getClientId()) {
    if (site === 'chegg') {
      init({
        env: env,
        clientId: OAProfileCode.CHEGG
      });
    } else {
      init({
        env: env,
        clientId: getProfileCode(site),
        domainUrl: cookieDomain,
        cookieDomain: cookieDomain,
        authGateUrl: "https://".concat(authGateUrlSubDomain).concat(cookieDomain, "/auth-gate/graphql")
      });
    }
  }
  if (!(props.onUploadSuccess || props.editorBaseUrl)) {
    throw new Error("".concat(ERROR_ONE_PROP_REQUIRED, " Neither prop is defined."));
  }
  var _React$useState = React.useState(function () {
      return configureStore({
        editorBaseUrl: editorBaseUrl,
        onUploadSuccess: onUploadSuccess,
        authApiUrl: authApiUrl,
        onAuthUpdate: onAuthUpdate,
        site: site,
        wtaiUploadUrl: wtaiUploadUrl,
        wtaiExpressUrl: wtaiExpressUrl,
        affiliateConfig: affiliateConfig,
        app: _objectSpread(_objectSpread({}, initialAppState), {}, {
          pasteOnly: !!pasteOnly,
          initRSW: !!initRSW,
          initFreshToken: !!initFreshToken,
          checkCategory: checkCategory || null,
          isResubmit: isResubmit
        })
      });
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    store = _React$useState2[0];
  var appProps = {
    headingText: headingText,
    subheadingText: subheadingText,
    pasteOnly: pasteOnly,
    alignText: alignText,
    includeTerms: includeTerms,
    termsTextColor: termsTextColor,
    demoTextEnabled: demoTextEnabled,
    isResubmit: isResubmit,
    filename: filename,
    onEnterText: onEnterText,
    onCtaActivated: onCtaActivated,
    onComputerCtaClicked: onComputerCtaClicked,
    onGoogleDriveCtaClicked: onGoogleDriveCtaClicked,
    onCtaClicked: onCtaClicked
  };
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(App, appProps));
};
Dropin.defaultProps = defaultProps;
export default Dropin;